// extracted by mini-css-extract-plugin
export default {"container":"go-back-button_container__FEDnX"};